export default "__VITE_ASSET__Bqh0Hu2J__"